import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import totalESIndexModel from "models/TotalESIndex";

class TotalESIndex extends React.Component {
  constructor() {
    super();
    this.makeCharts = this.makeCharts.bind(this);
    this.makeChart = this.makeChart.bind(this);
  }
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data;
  }
  makeCharts(datas, index) {
    return datas.reduce((arr, { attrs, data }) => {
      const values = [index, ...data.map(({ itemData }) => itemData)];
      const xCategories = ["全体", ...data.map(({ items }) => items)];
      arr.push(
        <Fragment key={`${attrs}-graph`}>
          <ReactHighcharts
            config={totalESIndexModel(values, xCategories, ` 【${attrs}】`)}
          />
        </Fragment>
      );
      return arr;
    }, []);
  }
  // arrtCount < 10の場合
  makeChart(datas, index) {
    const itemDataList = datas.map(({ data }) =>
      data.map(({ itemData }) => itemData)
    );
    const values = [index, ...[].concat(...itemDataList)];
    const itemList = datas.map(({ data }) => data.map(({ items }) => items));
    const xCategories = ["全体", ...[].concat(...itemList)];
    return (
      <Fragment>
        <ReactHighcharts config={totalESIndexModel(values, xCategories)} />
      </Fragment>
    );
  }
  render() {
    if (this.props.attrCount < 10) {
      return this.makeChart(this.props.data, this.props.index);
    }
    return (
      <Fragment>{this.makeCharts(this.props.data, this.props.index)}</Fragment>
    );
  }
}

TotalESIndex.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  attrCount: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired
};

export default TotalESIndex;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/TotalESIndex.jsx